import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { closeModal } from "../store/casinoConversion/casinoConversion.slice";

const modalRoot = document.querySelector("#modal-root");

const CasinoConversion = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { open, rate, pendingNavigation } = useSelector(
    (state) => state.casinoConversion,
  );

  // const handleAgree = () => {
  //   dispatch(closeModal());
  //   if (pendingNavigation?.gameId && pendingNavigation?.tableId) {
  //     navigate(
  //       `/casino-live/${pendingNavigation.gameId}/${pendingNavigation.tableId}`,
  //     );
  //   }
  //   if (pendingNavigation?.id) {
  //     navigate(
  //       `/casino-live/${pendingNavigation.id}/${pendingNavigation.tableId}`,
  //     );
  //   }
  // };

  const handleAgree = () => {
    dispatch(closeModal());

    if (pendingNavigation?.path) {
      navigate(pendingNavigation.path);
    }
    setTimeout(() => {
      dispatch(closeModal());
    }, 500);
  };

  const handleClose = () => {
    dispatch(closeModal());
  };

  if (!open) return null;

  return createPortal(
    <>
      {open && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-fadeIn">
          <div className="relative  w-full max-w-lg bg-gradient-to-br from-white via-gray-50 to-gray-100 rounded-3xl shadow-2xl overflow-hidden animate-slideUp">
            <button
              onClick={handleClose}
              className="absolute top-6 right-6 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-gray-900 hover:bg-gray-800 text-white transition-all duration-200 hover:scale-110"
              aria-label="Close modal"
            >
              X
            </button>

            <div className="relative px-8 py-8 md:px-12 md:py-16">
              <div className="mb-0 flex justify-center">
                <div className="relative"></div>
              </div>

              <div className="text-center space-y-6 mb-4">
                <h2 className="text-2xl md:text-3xl   font-bold text-gray-900 tracking-tight">
                  PLEASE NOTE
                </h2>

                <div className="inline-block bg-gradient-to-r from-amber-400 via-yellow-500 to-orange-500 text-white px-8 py-2 rounded-2xl shadow-lg">
                  <p className="text-2xl font-bold">1 Point = ₹{rate}</p>
                </div>

                <div className="space-y-4 pt-1">
                  <p className="text-lg md:text-xl font-semibold text-gray-800">
                    Welcome to your new casino lobby
                  </p>
                </div>
              </div>

              <button
                onClick={handleAgree}
                className="w-full bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 hover:from-gray-800 hover:via-gray-700 hover:to-gray-800 text-white font-bold text-lg py-2 px-8 rounded-xl shadow-lg transition-all duration-200 transform hover:scale-[1.02] hover:shadow-xl active:scale-[0.98]"
              >
                OK, I AGREE!
              </button>
            </div>

            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-amber-400 via-yellow-500 to-orange-500" />
          </div>
        </div>
      )}
    </>,
    modalRoot,
  );
};

export default CasinoConversion;
